import { SelfServiceClient } from '@/insession/SelfService/SelfServiceClient';
import { HeartBeat } from '@/insession/HeartBeat/HeartBeat';
import {
  ISelfServiceClient,
  IHeartBeat,
  IReportHeartbeatTask,
} from '@amzn/work-spaces-web-client-core-lib';
import { CoreFactory } from '@bridge/factory/CoreFactory';
import { ReportHeartbeatTask } from '@/insession/HeartBeat/ReportHeartbeatTask';
import { PreSessionFactory } from '@bridge/factory/PreSessionFactory';

export class InSessionFactory {
  private static selfServiceClient: ISelfServiceClient;
  private static heartBeat: IHeartBeat;
  private static reportHeartbeatTask: IReportHeartbeatTask;

  static getSelfServiceClient(): ISelfServiceClient {
    if (!this.selfServiceClient) {
      this.selfServiceClient = new SelfServiceClient(
        CoreFactory.getWsBrokerClient(),
        CoreFactory.getSessionManager(),
        PreSessionFactory.getSessionProvisionModule(),
        CoreFactory.getLogger()
      );
    }

    return this.selfServiceClient;
  }

  static getHeartBeat(): IHeartBeat {
    if (!this.heartBeat) {
      this.heartBeat = new HeartBeat(
        CoreFactory.getWsBrokerClient(),
        CoreFactory.getSessionManager(),
        CoreFactory.getLogger(),
        CoreFactory.getMetrics(),
        CoreFactory.getHeartBeatCore()
      );
    }

    return this.heartBeat;
  }

  static getReportHeartbeatTask(): IReportHeartbeatTask {
    if (!this.reportHeartbeatTask) {
      this.reportHeartbeatTask = new ReportHeartbeatTask({
        heartbeat: this.getHeartBeat(),
        logger: CoreFactory.getLogger(),
        sessionManager: CoreFactory.getSessionManager(),
      });
    }

    return this.reportHeartbeatTask;
  }
}
